import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { AlertCircle } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-black mb-4">
          Términos de Uso
        </h1>
        <p className="text-gray-600 mb-8">Última actualización: Diciembre 2025</p>

        <div className="bg-gray-50 border-2 p-6 rounded-lg mb-8">
          <p className="text-gray-700 font-medium">
            Al usar Video Vault, aceptás estos términos.
          </p>
        </div>

        <div className="space-y-6">
          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">1) Uso permitido</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 mb-4">
                La herramienta está destinada a facilitar la descarga de videos públicos.
              </p>
              <p className="text-gray-700">
                Recomendamos usarla para contenido propio o contenido con permiso del autor.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">2) Responsabilidad del usuario</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 mb-4">El usuario es responsable de:</p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Verificar que tiene derechos o autorización para descargar y usar el contenido.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Cumplir leyes aplicables (derechos de autor, propiedad intelectual) y reglas de la plataforma origen.</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-2 bg-red-50">
            <CardHeader>
              <div className="flex items-start gap-3">
                <AlertCircle className="h-6 w-6 text-red-600 flex-shrink-0 mt-1" />
                <CardTitle className="text-xl">3) Uso NO permitido</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 mb-4">No se permite usar el sitio para:</p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-1">✗</span>
                  <span>Infringir derechos de autor o distribuir contenido sin autorización.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-1">✗</span>
                  <span>Intentar acceder a contenido privado o restringido.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold mt-1">✗</span>
                  <span>Automatizar abusivamente el servicio (bots, scraping masivo, ataques).</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">4) Disponibilidad y cambios</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                El servicio se ofrece "tal cual". Puede fallar o cambiar sin previo aviso debido a 
                cambios en la plataforma origen o mantenimiento.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">5) Limitación de responsabilidad</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 mb-4">Video Vault no se hace responsable por:</p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Uso indebido por parte de usuarios.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Daños indirectos o pérdidas derivadas del uso del servicio.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Cambios en la disponibilidad del contenido de terceros.</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-2 bg-gray-50">
            <CardHeader>
              <CardTitle className="text-xl">6) Contacto</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Para consultas legales o reportes:{' '}
                <a href="mailto:support@cloudcentercr.com" className="font-semibold text-black hover:underline">
                  support@cloudcentercr.com
                </a>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Terms;
